import { clsx } from 'clsx';
import { FC } from 'react';
import { getVideolayserEmbededUrl } from 'modules/media';
import styles from './styles.module.css';

export const VideolyserPlayer: FC<{ url: string }> = ({ url }) => {
  try {
    const href = getVideolayserEmbededUrl(url);

    return (
      <iframe
        src={href}
        className={clsx(styles.player, styles.videolyserPlayer)}
      />
    );
  } catch (e) {
    console.error(e);
    return null;
  }
};
